import React, { Component } from 'react';
import { object } from 'prop-types';
import { Route } from 'react-router-dom';

import MainContent from './MainContent';

class Routes extends Component {
  static propTypes = {
    group: object.isRequired,
  };

  renderTabsRoutes = (tabs, page) => {
    const { group } = this.props;

    return tabs.map(tab => {
      const path = group.pages
        ? `${group.path}/${page.path}/${tab.path}`
        : `${group.path}/${tab.path}`;

      return this.renderRoute({
        component: tab.component,
        label: tab.label,
        subtitle: group.label,
        tabs: page.tabs,
        title: page.label,
        path,
      });
    });
  }

  renderRoute = route => (
    <Route
      key={route.path}
      path={'/' + route.path}
      exact={route.path === '/'}
      component={() =>
        <MainContent
          component={route.component}
          title={route.title}
          subtitle={route.subtitle}
          tabs={route.tabs}
        />
      }
    />
  );

  render() {
    const { group } = this.props;

    const routes = group.pages
      ? group.pages.map(page => this.renderTabsRoutes(page.tabs, page))
      : group.tabs
        ? this.renderTabsRoutes(group.tabs, group)
        :this.renderRoute({ ...group, title: group.label });

    return routes;
  }
}

Routes.displayName = 'Routes';

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js